
import React from "react";

import TextSlides from "./TextSlides";


function ReplaceText() {


  return (
    <>
    <section className="section-padding"> 
    <div className="section-title text-gradient text-center">Find & Replace  </div>
          <div className="section-subTitle text-center padd-title">
          Easily search for specific words or phrases and replace them in seconds with the Find and Replace Text tool.                 
          </div>
    </section>

    <section className="section-padding"> 
        <div className="container">
        <TextSlides/>   
        </div>
         </section>

    </>
  );
};



export default ReplaceText;
